




import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

import lottie, { AnimationConfigWithData, SVGRendererConfig } from 'lottie-web';

export interface LottieOptions {
  animationData: Record<string, any>;
  loop: boolean;
  autoplay: boolean;
  rendererSettings?: SVGRendererConfig;
}

@Component
export default class LottieAnimation extends Vue {
  @Prop(Object) readonly options!: LottieOptions;

  animation: any = null;

  initAnimation() {
    const { animationData, rendererSettings, loop = true, autoplay = true } = this.options;

    const opts: AnimationConfigWithData = {
      loop,
      autoplay,
      animationData,
      rendererSettings,
      container: this.$refs.container as Element,
      renderer: 'svg',
    };
    this.animation = lottie.loadAnimation(opts);
    this.$emit('animationCreated', this.animation);
    this.addCompleteListener();
  }

  destroyAnimation() {
    this.animation.destroy();
    this.animation = null;
  }

  @Watch('options')
  onOptionsChanged() {
    this.destroyAnimation();
    this.initAnimation();
  }

  addCompleteListener() {
    this.animation.addEventListener('complete', () => {
      this.$emit('animation-complete');
    });
  }

  mounted() {
    this.initAnimation();
  }

  beforeDestroy() {
    this.destroyAnimation();
  }
}
